<template>
  <DialogLayout
    ref="leaveAlertDialog"
    title="message.dataNotSaved"
    btnAlign="center"
    enableCancel
    cardContentClass="px-3 pt-8 pb-4"
    @close="_dialogAction"
    :maxWidth="500"
    disableCloseHide
  >
    {{ $t('message.dataNotSavedMsg') }}
  </DialogLayout>
</template>

<script>
import DialogLayout from '@/components/layout/DialogLayout.vue';
import { mapState } from 'vuex'

export default {
  name: 'ConfirmLeaveDialog',
  components: {
    DialogLayout,
  },
  computed: {
    ...mapState({
      toLink: state => state.LeaveAlertHelper.toLink,
    }),
    show() {
      return this.$store.state.LeaveAlertHelper.showDialog
    },
  },
  watch: {
    show(val) {
      if (this.$refs && this.$refs.leaveAlertDialog) {
        if (val) {
          this.$refs.leaveAlertDialog.show()
        } else {
          this.$refs.leaveAlertDialog.hide()
        }
      }
    },
  },
  methods: {
    async _dialogAction(action) {
      if (action === true && this.toLink) {
        await this.$store.dispatch('setDataIsUpdated', false)
        this.$router.replace(this.toLink)
      }

      this.$store.dispatch('closeLeaveAlert')
    },
  },
}
</script>
